import { createContext } from "react";

import type useAuthenticatedUser from "src/hooks/authentication/useAuthenticatedUser";

/**
 * Describes the authenticated-user API state exposed to context consumers.
 */
export interface IAuthenticatedUserContext extends ReturnType<typeof useAuthenticatedUser> {}

/**
 * Provides authenticated-user request state and refresh controls.
 *
 * Postconditions: Without a provider, data/error are undefined and activity flags are false;
 * default mutate/refresh promises fulfill with undefined and do not issue requests.
 */
export const AuthenticatedUserContext = createContext<IAuthenticatedUserContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});

export default AuthenticatedUserContext;
